import { useJoinNetwork, useJoinNetworkWithLink, useJoinNetworkWithToken, } from '../auth';
export const useSignup = (props) => {
    const { invitationToken, invitationLinkId } = props;
    const joinNetworkMutation = useJoinNetwork();
    const joinNetworkWithTokenMutation = useJoinNetworkWithToken();
    const joinNetworkWithLinkMutation = useJoinNetworkWithLink();
    const signupAsync = (variables, useMutationOptions) => {
        if (invitationLinkId) {
            return joinNetworkWithLinkMutation.mutateAsync({
                input: { ...variables.input, invitationLinkId },
            }, useMutationOptions);
        }
        if (invitationToken) {
            delete variables.input.email;
            return joinNetworkWithTokenMutation.mutateAsync({
                input: { ...variables.input, token: invitationToken },
            }, useMutationOptions);
        }
        return joinNetworkMutation.mutateAsync(variables, useMutationOptions);
    };
    return {
        mutateAsync: signupAsync,
        isLoading: joinNetworkMutation.isLoading ||
            joinNetworkWithLinkMutation.isLoading ||
            joinNetworkWithTokenMutation.isLoading,
    };
};
//# sourceMappingURL=useSignup.js.map